"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var PostViewSelectOptions_1 = require("../../../../constants/PostViewSelectOptions");
var react_i18next_1 = require("react-i18next");
var styles_module_scss_1 = __importDefault(require("../ConstructorBankSelectOption/styles.module.scss"));
var PersonalBank = function () {
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement(semantic_ui_react_1.Dropdown, { fluid: true, selection: true, disabled: true, className: styles_module_scss_1.default.dropdown, options: [
            {
                value: PostViewSelectOptions_1.DefaultBankOption.text,
                text: t(PostViewSelectOptions_1.DefaultBankOption.text),
                image: PostViewSelectOptions_1.DefaultBankOption.image,
            },
        ], value: PostViewSelectOptions_1.DefaultBankOption.text }));
};
exports.default = PersonalBank;
